import type { PointLight } from "@babylonjs/core/Lights/pointLight";
import type { Vector3 } from "@babylonjs/core/Maths/math.vector";
import type { AbstractMesh } from "@babylonjs/core/Meshes/abstractMesh";

export function restrictLightToNearbyMeshes(
  light: PointLight,
  meshes: readonly AbstractMesh[],
  origin: Vector3,
  range: number,
): void {
  light.includedOnlyMeshes.length = 0;
  const rangeSquared = range * range;
  for (const mesh of meshes) {
    if (!mesh.material) continue;
    if (mesh.metadata?.surface === "torch") continue;
    mesh.computeWorldMatrix(true);
    const bounds = mesh.getBoundingInfo().boundingBox;
    if (distanceSquaredToBounds(origin, bounds.minimumWorld, bounds.maximumWorld) <= rangeSquared) {
      light.includedOnlyMeshes.push(mesh);
    }
  }
}

function distanceSquaredToBounds(origin: Vector3, minimum: Vector3, maximum: Vector3): number {
  const deltaX = Math.max(minimum.x - origin.x, 0, origin.x - maximum.x);
  const deltaY = Math.max(minimum.y - origin.y, 0, origin.y - maximum.y);
  const deltaZ = Math.max(minimum.z - origin.z, 0, origin.z - maximum.z);
  return deltaX * deltaX + deltaY * deltaY + deltaZ * deltaZ;
}
